import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import type { Suggestions } from '@mint-sdk/api-recommendations';

import WidgetCarousel from '../WidgetCarousel/WidgetCarousel.jsx';

type KpiWidgetProps = {
  suggestion: Suggestions.SuggestionResponseType;
};

const KpiWidget = ({ suggestion }: KpiWidgetProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-center gap-2">
        <p className={typographyVariants({ variant: 'h4' })}>
          {t('Forecasted KPIs')}
        </p>
      </div>
      <WidgetCarousel suggestion={suggestion} />
    </div>
  );
};

export default KpiWidget;
